import { callGuestAPI } from "../axios/guestAxios";

async function sendPaymentConfirmation(data) {
  const options = {
    method: "POST",
    url: "/reservation/v1/send-payment-confirmation",
    data,
  };
  const res = await callGuestAPI(options);
  return res;
}

async function sendPayLaterConfirmation(data) {
  const options = {
    method: "POST",
    url: "/reservation/v1/send-paylater-email",
    data,
  };
  const res = await callGuestAPI(options);
  return res;
}

const EmailServices = {
  sendPaymentConfirmation,
  sendPayLaterConfirmation,
};

export default EmailServices;